export default (place) => {
  if (!place?.address_components) return undefined;

  const preciseLocation = place.address_components.filter((ac) => ac.types.indexOf('route') > -1).length > 0;

  let targetAddress = place.formatted_address;
  if (targetAddress.endsWith(', USA')) {
    targetAddress = targetAddress.slice(0, -5);
  }

  const extractAddress = (addressComponents) => {
    const streetNumberComponent = addressComponents.find(
      (component) => component.types.includes('street_number'),
    );

    const routeComponent = addressComponents.find(
      (component) => component.types.includes('route'),
    );

    if (!streetNumberComponent && !routeComponent) {
      return undefined;
    }

    const streetNumber = streetNumberComponent?.long_name || streetNumberComponent?.short_name;
    const route = routeComponent?.long_name || routeComponent?.short_name;

    return [streetNumber, route].join(' ');
  };

  const extractState = (addressComponents) => {
    const stateComponent = addressComponents.find(
      (component) => component.types.includes('administrative_area_level_1'),
    );

    if (!stateComponent) {
      return undefined;
    }

    return stateComponent.short_name;
  };

  const extractCity = (addressComponents) => {
    const cityComponent = addressComponents.find((component) => component.types.includes('locality'))
      || addressComponents.find((component) => component.types.includes('neighborhood'))
      || addressComponents.find((component) => component.types.includes('sublocality_level_1'))
      || addressComponents.find((component) => component.types.includes('sublocality'));

    if (!cityComponent) {
      return undefined;
    }

    return cityComponent.long_name || cityComponent.short_name;
  };

  const extractZip = (addressComponents) => {
    const zipComponent = addressComponents.find(
      (component) => component.types.includes('postal_code'),
    );

    if (!zipComponent) {
      return undefined;
    }

    return zipComponent.short_name;
  };

  const extractCounty = (addressComponents) => {
    const countyComponent = addressComponents.find(
      (component) => component.types.includes('administrative_area_level_2'),
    );

    if (!countyComponent) {
      return undefined;
    }

    return countyComponent.long_name || countyComponent.short_name;
  };

  const extractNeighborhood = (addressComponents) => {
    const neighborhoodComponent = addressComponents.find(
      (component) => component.types.includes('neighborhood'),
    );

    if (!neighborhoodComponent) {
      return undefined;
    }

    return neighborhoodComponent.long_name || neighborhoodComponent.short_name;
  };

  const { location } = place.geometry;
  return {
    lat: location.lat instanceof Function ? location.lat() : location.lat,
    lon: location.lng instanceof Function ? location.lng() : location.lng,
    targetAddress,
    address: extractAddress(place.address_components),
    // TODO: remove streetAddress once we refactor everywhere it's used
    streetAddress: extractAddress(place.address_components),
    city: extractCity(place.address_components),
    // TODO: remove city_long once we refactor everywhere it's used
    city_long: extractCity(place.address_components),
    state: extractState(place.address_components),
    zip: extractZip(place.address_components),
    preciseLocation,
    county: extractCounty(place.address_components),
    neighborhood: extractNeighborhood(place.address_components),
  };
};
